import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

const DeleteDialog = ({ open, onClose, onConfirm, permissionName }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete Permission</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the permission <strong>"{permissionName}"</strong>?
          <br />
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDialog;